import requester from '@/lib/axios';
import { FlashcardQuestion, FlashcardQuestionDTO } from '@/models/Question';

const baseUrl = 'flashcard-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getFlashcardQuestion = async (id: number) => {
  const { data: flashcardQuestion } = await requester().get<FlashcardQuestion>(
    `${baseUrl}/${id}/`,
  );

  return flashcardQuestion;
};

export const createFlashcardQuestionIntoActivity = async (
  activityId: number,
  body: FlashcardQuestionDTO,
) => {
  const { data } = await requester().post<FlashcardQuestion>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateFlashcardQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: FlashcardQuestionDTO,
) => {
  const { data } = await requester().patch<FlashcardQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteFlashcardQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
